// extracted by mini-css-extract-plugin
export default {"card":"HeroImageCard__card-pjm4","title":"HeroImageCard__title-KTfR","details":"HeroImageCard__details-zVmX","component":"HeroImageCard__component-KsFn"};